import '../App.css';
import React from 'react'

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        {/* Column 1 */}
        <div className="footer-column">
          <div className="logo">
          <span className="logo-name"><img width="50" height="50" src="https://img.icons8.com/nolan/64/avermedia.png" alt="avermedia"/>  Vortex Gym</span>
          </div>
          <p>Welcome to Vortex Gym! We are dedicated to helping you achieve your fitness goals.Take your health and body to the next level with our comprehensive program designed to help you reach your fitness goals. Join us and start your journey today!.</p>
          <div className="social-media">
          <a href="https://www.linkedin.com/in/vrushabh-somani-2b0603206/" target="_blank"><img width="30" height="30" src="https://img.icons8.com/fluency/30/linkedin.png" alt="linkedin"/></a>
            <a href="https://www.instagram.com/vrushabhsomani/" target="_blank"><img width="30" height="30" src="https://img.icons8.com/fluency/30/instagram-new.png" alt="instagram-new"/></a>
            <a href="https://x.com/VrushabhSomani" target="_blank"><img width="30" height="30" src="https://img.icons8.com/windows/30/twitterx.png" alt="twitterx"/></a>
            <a href="https://www.facebook.com/VrushabhSomani/" target="_blank"><img width="30" height="30" src="https://img.icons8.com/color/96/facebook-new.png" alt="facebook-new"/></a>
          </div>
          <p>&copy; 2024 Vortex Gym. All rights reserved.</p>
        </div>

        {/* Column 2 */}
        <div className="footer-column">
          <h3>Our Classes</h3>
          <ul>
            <li>Yoga</li>
            <li>Cardio</li>
            <li>Crossfit</li>
            <li>Boxing</li>
            <li>Combat Techniques</li>
            <li>Strength & Conditioning</li>
          </ul>
        </div>

        {/* Column 3 */}
        <div className="footer-column">
          <h3>Working Hours</h3>
          <div className="working-hours">
            <div className="weekday">
              <span>Monday to Saturday</span>
              <br />
              <span className="time">5:00 am - 10:00 pm</span>
            </div>
            <div className="weekday">
            <br />
              <span>Sunday</span>
              <br />
              <span className="time">6:00 am - 2:00 pm</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
